export default "__VITE_ASSET__878d7fdd__"